// extracted by mini-css-extract-plugin
export default {"acknowledgementsContainer":"AcknowledgmentForApp_acknowledgementsContainer__Owmjz","acknowledgementsContent":"AcknowledgmentForApp_acknowledgementsContent__77xDY"};